import { PhraseValue } from 'hooks/business/usePhraseOnChat';
import { PhrasesTextElement } from 'services/api/phrase';

export const getFillPhraseText = (data: PhrasesTextElement, opened: boolean) => {
  const { text } = data;
  const { content, translationContent } = text;
  if (opened) {
    return content || translationContent;
  } else {
    return translationContent || content;
  }
};

export const sortPhraseList = (list?: PhraseValue[]) => {
  if (!list) return [];
  return list.sort((a, b) => {
    // groupType 为 PERSONAL 排在前面
    if (a.groupType === 'PERSONAL' && b.groupType !== 'PERSONAL') return -1;
    if (a.groupType !== 'PERSONAL' && b.groupType === 'PERSONAL') return 1;
    return 0;
  });
};
